import { useEffect, useMemo, useState } from 'react';
import { getTimeSignals } from '../room/useRoomPhase';

export const OWNER_CONSOLE_TIME_SIGNAL_INTERVAL_MS = 1000;

export default function useOwnerConsoleTimeSignals(
  round,
  intervalMs = OWNER_CONSOLE_TIME_SIGNAL_INTERVAL_MS,
  betCloseMode = 'timer'
) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timeoutId = null;
    let active = true;

    if (!intervalMs) {
      return undefined;
    }

    const tick = () => {
      if (!active) {
        return;
      }

      const nextNow = new Date();
      const nextSignals = getTimeSignals(round, nextNow);
      setNow(nextNow);

      if (
        betCloseMode !== 'manual' &&
        (
          nextSignals.timePhase === 'ended' ||
          nextSignals.countdownSeconds === null ||
          nextSignals.countdownSeconds === undefined ||
          nextSignals.countdownSeconds === 0
        )
      ) {
        return;
      }

      timeoutId = setTimeout(tick, intervalMs);
    };

    tick();

    return () => {
      active = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [round?.id, round?.number, round?.starttime, round?.fasttime, round?.endtime, intervalMs, betCloseMode]);

  return useMemo(() => {
    const signals = getTimeSignals(round, now);
    const starttime = round?.starttime ? new Date(round.starttime) : null;
    const elapsedSeconds = starttime && !Number.isNaN(starttime.getTime())
      ? Math.max((now.getTime() - starttime.getTime()) / 1000, 0)
      : null;

    return { ...signals, elapsedSeconds };
  }, [
    round?.starttime,
    round?.fasttime,
    round?.endtime,
    round?.id,
    round?.number,
    now,
  ]);
}
